import { AxiosGlobal } from "../shared/axios";
import { AxiosPromise } from "axios";
import configs from "../../configs";
import { store } from "../../Components/store/store";

export class AdinLiveApis extends AxiosGlobal {

    getPaymentHistory(pageNo: any, query: any): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/admin/payment-history?page=${pageNo}&search=${query?.search}`, {
            headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    getAllStudentLoan(pageNo: any, query: any): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/dashboard/get-all-loan?page=${pageNo}&search=${query?.search}`, {
            headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    getSingleLoan(id: any): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/dashboard/get-single-loan/${id}`, {
            headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    getAllCreditEligibility(pageNo: any, query: any): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/credit-eligibility/get-all-credit-form?page=${pageNo}&search=${query?.search}`, {
            headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    getAllSchoolForm(pageNo: any, query: any): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/credit-eligibility/get-all-school-form?page=${pageNo}&search=${query?.search}`, {
            headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    getSingleCreditEligibilityForm(user_id: any): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/credit-eligibility/get-single-credit-form/${user_id}`, {
            headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    getSingleSchoolForm(user_id: any): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/credit-eligibility/get-single-school-form/${user_id}`, {
            headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    getAllUsers(pageNo: any, query: any): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/admin/get-all-users?page=${pageNo}&search=${query?.search}`, {
            headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    getAllSurveys(pageNo: any, query: any): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/admin/get-all-surveys?page=${pageNo}&search=${query?.search}`, {
            headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    getSingleUser(id: any): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/admin/get-single-user/${id}`, {
            headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    updateStatus(id: any, data: any): AxiosPromise<Array<any>> {
        return this.axios.put(`${configs.context}/admin/change-status/${id}`, data, {
            headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    getStatistics(): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/admin/get-statistics`, {
            headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    // Email Campaign APIs
    getAllEmailCampaigns(pageNo: any, query: any): AxiosPromise<Array<any>> {
        const params = new URLSearchParams({
            page: pageNo.toString(),
            search: query?.search || '',
            status: query?.status || 'all',
            per_page: query?.per_page || '10'
        });

        return this.axios.get(`${configs.context}/admin/email-campaigns?${params}`, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    createEmailCampaign(data: any): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.context}/admin/email-campaigns`, data, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    getSingleEmailCampaign(id: any): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/admin/email-campaigns/${id}`, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    sendEmailCampaign(id: any): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.context}/admin/email-campaigns/${id}/send`, {}, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    deleteEmailCampaign(id: any): AxiosPromise<Array<any>> {
        return this.axios.delete(`${configs.context}/admin/email-campaigns/${id}`, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    previewEmailRecipients(criteria: any): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.context}/admin/email-campaigns/preview-recipients`, criteria, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    getEmailCampaignStatistics(): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/admin/email-campaigns/statistics`, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    // New method for validating custom emails
    validateCustomEmails(emails: any): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.context}/admin/email-campaigns/validate-emails`, { emails }, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    // New method for getting campaign breakdown
    getEmailCampaignBreakdown(id: any): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/admin/email-campaigns/${id}/breakdown`, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
        });
    }
}